module.exports = __webpack_public_path__ + "static/img/16-Thames-tideway-tunnel.292b826f.jpg";